
import modelBase from '../../models/model-base.model';
import { apiStatusCodes } from '../../config/global-variables';

var tagModel = {

    getTagsList: function (successCallBack, failureCallBack, projectId, searchTagOrDescription, pageIndex, pageSize) {
        var path = '/api/objectdetection/projects/' + projectId + '/tags' + '?SearchTagOrDescription='+ searchTagOrDescription + '&PageIndex=' + pageIndex + '&PageSize=' + pageSize;
        modelBase.get(successCallBack, failureCallBack, path, {});
    },

    getTagStatisticsList: function (successCallBack, failureCallBack, projectId) {
        var path = '/api/objectdetection/projects/' + projectId + '/tag-statistics';
        modelBase.get(successCallBack, failureCallBack, path, {});
    },

    getTag: function (successCallBack, failureCallBack, projectId, tagId) {
        var path = '/api/objectdetection/projects/' + projectId + '/tags/' + tagId;
        modelBase.get(successCallBack, failureCallBack, path, {});
    },

    createNewTag: function (successCallBack, failureCallBack, listOfTags, projectId, tagName, tagDescription) {
        var tag = {};
        tag.tag = tagName.trim();
        tag.description = tagDescription;

        if (tag.tag.length == 0) {

            let error = new Error();
            error.code = apiStatusCodes.badRequest;
            error.response = [];
            error.response.push({ code: "LT00000010XX", message: "Please enter a name for the tag." });
            
            failureCallBack(error);

            return;
        } else {
            for(var i = 0; i < listOfTags.length; i++) {
                if (listOfTags[i].name == tag.tag.toUpperCase()) {
                    let error = new Error();
                    error.code = apiStatusCodes.badRequest;
                    error.response = [];
                    error.response.push({ code: "LT00000010XX", message: "The tag already exists." });
                    
                    failureCallBack(error);

                    return;
                }
            }
        }

        var tags = [];
        tags.push(tag);

        var params = {};
        params.items = tags;

        var path = '/api/objectdetection/projects/' + projectId + '/tags';
        modelBase.post(successCallBack, failureCallBack, path, { body:params });
    },

    editTag: function (successCallBack, failureCallBack, listOfTags, projectId, tagId, tagName, tagDescription) {
        var tag = {};
        tag.id = tagId;
        tag.tag = tagName.trim();
        tag.description = tagDescription;

        if (tag.tag.length == 0) {

            let error = new Error();
            error.code = apiStatusCodes.badRequest;
            error.response = [];
            error.response.push({ code: "LT00000010XX", message: "Please enter a name for the tag." });
            
            failureCallBack(error);

            return;
        }

        var tags = [];
        tags.push(tag);

        var params = {};
        params.items = tags;

        var path = '/api/objectdetection/projects/' + projectId + '/updatetags';
        modelBase.post(successCallBack, failureCallBack, path, { body: params });
    },

    deactivateTag: function (successCallBack, failureCallBack, projectId, tagId) {
        var tag = {};
        tag.tagId = tagId;

        var tags = [];
        tags.push(tag);

        var params = {};
        params.items = tags;

        var path = '/api/objectdetection/projects/' + projectId + '/tags/deactivate';
        modelBase.post(successCallBack, failureCallBack, path, { body:params });
    },

}




export default tagModel
